export default "__VITE_ASSET__Ar1hJ5$f__"